interface Props {
  size?: number;
  color?: string;
}

const TokenManagementIcon = (props: Props) => {
  const { color = '#000', size = 25 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox={`0 0 ${size} ${size}`}
    >
      <path
        d="M17.405 11.9185C17.405 14.9181 14.9733 17.3498 11.9738 17.3498M6.54249 11.9185C6.54249 8.91892 8.97414 6.48727 11.9738 6.48727M20.5865 11.9185C20.5865 16.7179 16.6959 20.6085 11.8965 20.6085C7.09719 20.6085 3.20654 16.7179 3.20654 11.9185C3.20654 7.11916 7.09719 3.22852 11.8965 3.22852C16.6959 3.22852 20.5865 7.11916 20.5865 11.9185Z"
        stroke={color}
        strokeWidth={1.76}
      />
    </svg>
  );
};

export default TokenManagementIcon;
